import React from 'react';
import Header from '../components/header';
import Content from '../components/content.js';
import Footer from "../components/Footer";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function Layout() {
  return (
   <>
    
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Header/>}>
          <Route index element={<Content/>} />
          <Route path="footer" element={<Footer/>} />
        </Route>
      </Routes>
    </BrowserRouter>
   </>
  );
}

export default Layout;